/*------------------------------------------------------------------
Import
------------------------------------------------------------------*/
import { $, $$ } from './lib'
import * as TEMPLATE from './templates';
import tingle from 'tingle.js';
import { Notyf } from 'notyf';
import * as SHOP from './shop';

let notyf = new Notyf({
    duration: 4000,
    dismissible: true,
    icon: false
});


document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('Toast\\Pages\\WishlistPage')) {
        let wishlist_once = false;
        let wishlist_captcha;

        if ($('.js-share-wishlist')) {

            // Click of share wishlist link 
            $('.js-share-wishlist').addEventListener('click', (e) => {
                e.preventDefault();

                // Test to see if the user is logged in
                let logged_out = e.target.dataset.member === 'false' ? true : false;

                // Get the item clicked
                let link = e.target.dataset.link;

                // Instanciate new modal
                let modal = new tingle.modal({
                    footer: true
                });

                // Set the modals content
                modal.setContent(TEMPLATE.wishlistShare(link, logged_out));

                try {
                    wishlist_captcha = grecaptcha.render("send_wishlist",
                        {
                            sitekey: window.recaptcha_site_key,
                            callback: (response) => {
                                onSubmitWishlist(response);
                            }
                        }
                    );

                } catch (error) {
                    grecaptcha.reset(wishlist_captcha);
                }

                // Open the modal
                modal.open();

                var onSubmitWishlist = (token) => {

                    let data = {
                        email: $('.js-email').value,
                        comments: $('.js-comments').value,
                        captcha_response: token
                    };

                    // Add a loading class to the button
                    $('.js-share-wishlist-form').querySelector('.button').classList.add('busy');

                    // Assign extra fields if a user is not logged in and sharing a form
                    if ($('.js-from-name')) Object.assign(data, { from_name: $('.js-from-name').value });
                    if ($('.js-from-email')) Object.assign(data, { from_email: $('.js-from-email').value });

                    fetch($('.js-share-wishlist').dataset.apiUrl, {
                        method: 'POST',
                        body: JSON.stringify(data),
                    }).then((response) => response.json())
                        .then((data) => {

                            // Show a success message
                            notyf.success({ message: data.message, icon: false });

                            // Reset the form
                            $('.js-share-wishlist-form').reset();

                            // Close the modal
                            modal.close();

                            // Add a loading class to the button
                            $('.js-share-wishlist-form').querySelector('.button').classList.remove('busy');

                            setTimeout(() => window.location.reload(), 100);

                        })
                        .catch((data) => {

                            // Close the modal
                            modal.close();

                            // Show an error message
                            notyf.success({ message: 'Something went wrong when sharing your wishlist', icon: false });
                        });

                    // });

                }

            });
        }


        // Click of share wishlist link 
        if ($('.js-download-wishlist')) {
            $('.js-download-wishlist').addEventListener('click', (e) => {
                e.preventDefault();

                // Download the wishlist dierctly if testing locally
                if (window.location.host === 'oliveri.test') window.location = '/wishlist/download?version=' + new Date().valueOf();
                if (window.location.host === 'oliveri.test') return false;

                // Instanciate new modal
                let modal = new tingle.modal({
                    footer: true,
                    onClose: () => modal.destroy()
                });

                // Set the modals content
                modal.setContent(TEMPLATE.wishlistDownload());


                modal.addFooterBtn('Generate download', 'button arrow-link', () => {

                    // Add a busy class to the download button
                    $('.tingle-modal-box__footer .button').classList.add('busy');

                    // Open a new window in the browser
                    let url = '/wishlist/download?version=' + new Date().valueOf();

                    // Fetch the images as a blob and then download them in window
                    fetch(url)
                        .then(response => response.blob())
                        .then(blob => {

                            // Add a busy class to the download button
                            $('.tingle-modal-box__footer .button').classList.remove('busy');

                            // Create a link to download the file in the current window
                            let a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style.display = 'none';
                            a.href = window.URL.createObjectURL(blob);
                            a.download = 'Oliveri-Resources';
                            a.click();
                            document.body.removeChild(a);

                            // Close the modal
                            modal.close();
                        });


                });

                // Open the modal
                modal.open();

                setTimeout(() => $('.tingle-modal-box__footer .button').insertAdjacentHTML('afterbegin', '<span class="buttonLoader" style="top:1rem;"></span>'), 100);
            });
        }

        if ($('.js-save-comment')) {

            $$('.js-save-comment').forEach((button) => {
                // Click of share wishlist link 
                button.addEventListener('click', (e) => {
                    e.preventDefault();

                    // Get the ID and Comment for the wishlist item
                    let id = e.target.dataset.id;
                    let comment = e.target.parentNode.querySelector('textarea').value;

                    // Edit a wishlist item comment
                    SHOP.editWishlistComment(id, comment)

                });
            });
        }
    }


});